import { useEffect, useMemo, useState } from "react";

import {
    LS_KEY_DOMAIN_HINT,
    SSO_QS_KEY_DOMAIN_HINT,
    SSO_QS_KEY_ORIGIN,
} from "../../../constants";
import { useLocalStorageState } from "../../../hooks/useLocalStorageState";

type QueryParams = { [key: string]: string };

export function useSsoQueryParameters(): {
    ssoQueryParameters: QueryParams,
    setDomainHint: (domainHint: string) => void;
    domainHintFromParams: string | null;
} {
    const [domainHint, setDomainHint] = useLocalStorageState({ lsKey: LS_KEY_DOMAIN_HINT });
    const [domainHintFromParams, setDomainHintFromParams] = useState<string | null>(null);

    const ssoQueryParameters: QueryParams = useMemo(() => ({
        [SSO_QS_KEY_ORIGIN]: window.location.origin,
        [SSO_QS_KEY_DOMAIN_HINT]: domainHint !== null ? domainHint : "",
    }), [domainHint]);

    useEffect(() => {
        const newDomainHintFromParams = new URLSearchParams(window.location.search).get(SSO_QS_KEY_DOMAIN_HINT);
        if (newDomainHintFromParams !== null) {
            let currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete(SSO_QS_KEY_DOMAIN_HINT);
            window.history.replaceState({}, document.title, currentUrl.toString());
            setDomainHint(newDomainHintFromParams);
            setDomainHintFromParams(newDomainHintFromParams);
        }
    }, [setDomainHint]);

    return {
        ssoQueryParameters: ssoQueryParameters,
        setDomainHint: setDomainHint,
        domainHintFromParams: domainHintFromParams,
    };
}
